import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function PainSection() {
  return <section aria-labelledby="dolor-titulo" className="ruled-paper w-full border-y border-navy/10 bg-white py-14 sm:py-20" data-id="element-205" data-mp="38wlvkxicj0ju">
      <div className="mx-auto max-w-3xl px-5" data-id="element-206" data-mp="2v0i5ngei9ed6">
        <h2 id="dolor-titulo" className="font-display text-3xl font-extrabold leading-tight text-navy text-balance sm:text-4xl" data-id="element-207" data-mp="2yypgxvq79ngz">
          ¿Cuántos domingos más vas a perder así?
        </h2>

        <div className="mt-6 space-y-5 text-base leading-relaxed text-navy/80 sm:text-lg" data-id="element-208" data-mp="2q0dkve6kdxh5">
          <p data-id="element-209" data-mp="2bbr89k8bnjtm">
            Son las 10 de la noche del domingo. Tenés tres pestañas abiertas, una ficha a
            medio terminar en Word y la sensación de que nada de lo que encontraste hoy
            encaja del todo con lo que necesita tu hijo/a — o tus alumnos.{' '}
            <strong className="font-bold text-navy" data-id="element-210" data-mp="278ulrifnv3ke">Mañana es lunes. Y volvés a improvisar.</strong>
          </p>
          <p data-id="element-211" data-mp="3rlpphius9if0">
            No es que no te importa. Es exactamente al revés: te importa tanto que llevás
            meses así. Buscando, armando, ajustando, dudando.
          </p>
          <p data-id="element-212" data-mp="5g2kimsuzoor">
            Y el problema no sos vos. El problema es que nadie juntó todo en un solo lugar
            — secuenciado, adaptado al español rioplatense, con guía para el adulto y
            progresión clara por nivel.{' '}
            <strong className="font-bold text-celeste-dark" data-id="element-213" data-mp="38wsvlg3asrxb">
              Ese sistema no existía. Hasta hoy.
            </strong>
          </p>
        </div>

        <ul className="mt-9 space-y-3" data-id="element-214" data-mp="3imm6eevm930i">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-xl border border-coral/15 bg-coral/5 px-4 py-3" data-id="element-215" data-mp="3dvw274yxf67e">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-216" data-mp="2q475lcf2nvkn" />
              <span className="text-sm leading-relaxed text-navy/85 sm:text-base" data-id="element-217" data-mp="2l6fbqcuv9zdt">
                {point}
              </span>
            </li>)}
        </ul>

        <div className="mt-10 text-center" data-id="element-218" data-mp="u23o1xx8rvqr">
          <p className="font-display text-xl font-bold text-navy sm:text-2xl" data-id="element-219" data-mp="u0slg1fj8u18">
            Eso no es falta de dedicación. Es falta de un sistema.
          </p>
          <p className="mt-2 font-display text-2xl font-extrabold text-celeste-dark sm:text-3xl" data-id="element-220" data-mp="12u5m5pju8zxv">
            ¿Y si este fuera el último domingo que pasás así?
          </p>
        </div>
      </div>
    </section>;
}